import styled from '@emotion/styled';
import * as main from '@shared/styles/abstracts/vars.module.scss';
import { SMagicBox } from '@shared/styles/styledComponentsCommon';
import { Card } from '@shared/ui/index';
import { ImageInputCropperM } from '@shared/ui/inputs/image-input-cropper/index';
import { TextareaM } from '@shared/ui/inputs/TextareaM';

export const SCard = styled(Card)`
  display: flex;
  flex-direction: row;
  padding: 10px;
  flex-grow: 1;
  gap: 10px;
`;

export const SImageInputCropperM = styled(ImageInputCropperM)`
  aspect-ratio: 16 / 9;
  max-height: 126px;
  max-width: 224px;
  @media (width < ${main.brpMobileL}) {
    width: 100%;
    max-height: unset;
    max-width: unset;
  }
  @media (width < 450px) {
    //height: 210px;
  }
`;

export const STextareaWrapper = styled(TextareaM)`
  height: 126px;
  @media (width < ${main.brpMobileL}) {
    //width: 100%;
    height: 100%;
  }
`;

export const SName = styled(SMagicBox)`
  @media (width > ${main.brpMobileL}) {
    display: none;
  }
`;
export const SNameNearImage = styled(SMagicBox)`
  flex-grow: 1;
`;
